/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".upload[_ngcontent-%COMP%]{color:gold;margin-top:50px;margin-left:50px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/themes/default/CSS/upload-media.component.less.shim.ngstyle.js.pre-build-optimizer.js